module.exports = __webpack_public_path__ + "img/github_oidc.95c893df.png";